<template>
    <div>
        <RelationshipPatent  />
        <div class="mt-5"><RelationshipTech  /></div>
    </div>
</template>

<script setup lang="ts">
import RelationshipPatent from '@/components/RelationshipPatent.vue';
import RelationshipTech from '@/components/RelationshipTech.vue';
</script>
